module.exports = __webpack_public_path__ + "img/B1.c3fc73f7.jpg";